import { render, staticRenderFns } from "./IconStatus.vue?vue&type=template&id=1950b721&scoped=true"
import script from "./IconStatus.vue?vue&type=script&lang=js"
export * from "./IconStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950b721",
  null
  
)

export default component.exports